import { EventEmitter, ViewChild } from '@angular/core';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';

@Component({
  selector: 'app-customer-order-notes',
  templateUrl: './customer-order-notes.component.html',
  styleUrls: ['./customer-order-notes.component.scss']
})
export class CustomerOrderNotesComponent implements OnInit {
  @Output() forcePendingChanges = new EventEmitter();
  @ViewChild('formNotes') formNotes: DxFormComponent;
  @Input('note') note: string;
  @Input('internalNote') internalNote: string;

  constructor() { }

  ngOnInit(): void {
  }

  onInitialized(){
    this.formNotes.formData.internalNote = this.internalNote;
    this.formNotes.formData.note = this.note;
  }

  notesFieldChanged(){
    this.note = this.formNotes.formData.note;
    this.internalNote = this.formNotes.formData.internalNote;
    this.forcePendingChanges.emit();
  }
}
